import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import { IEmailValidation } from './types';

export const getEmailDomains = (): IResponse<IEmailValidation> =>
  privateAxios({ method: 'get', url: 'settings/email-validation' });

export default getEmailDomains;
